import { selectFeatureFlag } from '../../selectors/feature-flags';

/**
 *
 * @returns {number}
 */
export const getTrailersHealthBatchSize = state => selectFeatureFlag(state, 'trailers-health-batch-size');
